import { Box, Text } from '@dtx-company/shared-components/src'
import React from 'react'

const SymptomText: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Text variant="body/small">{children}</Text>
)

export default {
  isSymptomatic: (
    <>
      <Text variant="body/small" mb="18px">
        Have you experienced any of the following symptoms in the past 48 hours:
      </Text>
      <Box flexDirection="column" alignItems="start">
        <SymptomText>Fever or chills</SymptomText>
        <SymptomText>Cough</SymptomText>
        <SymptomText>Shortness of breath or difficulty breathing</SymptomText>
        <SymptomText>Fatigue</SymptomText>
        <SymptomText>Muscle or body aches</SymptomText>
        <SymptomText>Headache</SymptomText>
        <SymptomText>New loss of taste or smell</SymptomText>
        <SymptomText>Sore throat</SymptomText>
        <SymptomText>Congestion or runny nose</SymptomText>
        <SymptomText>Nausea or vomiting</SymptomText>
        <SymptomText>Diarrhea</SymptomText>
      </Box>
    </>
  ),
  isInCloseContact: (
    <Text variant="body/small" fontWeight="bold">
      Within the past 14 days, have you been in close physical contact (6 feet or closer for at
      least 15 minutes) with a person who is known to have laboratory-confirmed COVID-19 or with
      anyone who has any symptoms consistent with COVID-19?
    </Text>
  ),
  isIsolating: (
    <Text variant="body/small" fontWeight="bold">
      Are you isolating or quarantining because you may have been exposed to a person with COVID-19
      or are worried that you may be sick with COVID-19?
    </Text>
  ),
  isWaitingOnResults: (
    <Text variant="body/small" fontWeight="bold">
      Are you currently waiting on the results of a COVID-19 test?
    </Text>
  )
}
